import React, { useState } from 'react'
import { SegmentedControl } from '../../components/SegmentedControl/SegmentedControl'
import { CROSS_CLIENT_QUERY_WALLET, CUSTOM_WORKFLOW_WALLET, type WalletType } from '../../models/Wallet'
import { type CreditConfig } from '../../models/Plan'
import { WalletTab } from './WalletTab'

interface WalletOption {
  walletType: WalletType
  label: string
  creditConfig: CreditConfig | null
}

interface WalletSectionProps {
  crossClientAvailable: boolean
  customWorkflowAvailable: boolean
  creditConfigs: Partial<Record<WalletType, CreditConfig>> | undefined
}

export const WalletSection: React.FC<WalletSectionProps> = ({ crossClientAvailable, customWorkflowAvailable, creditConfigs }) => {
  const options: WalletOption[] = []
  if (crossClientAvailable) {
    options.push({ walletType: CROSS_CLIENT_QUERY_WALLET, label: 'Cross-client query', creditConfig: creditConfigs?.crossClientQuery ?? null })
  }
  if (customWorkflowAvailable) {
    options.push({ walletType: CUSTOM_WORKFLOW_WALLET, label: 'Custom workflows', creditConfig: creditConfigs?.customWorkflow ?? null })
  }

  const [activeWallet, setActiveWallet] = useState<WalletType>(options[0]?.walletType ?? CROSS_CLIENT_QUERY_WALLET)
  const active = options.find((o) => o.walletType === activeWallet) ?? options[0]

  if (!active) return null

  return (
    <div className='d-flex flex-column zocks-gap-2'>
      {options.length > 1 ? (
        <SegmentedControl
          options={options.map((o) => ({ key: o.walletType, label: o.label, hideCount: true }))}
          activeKey={active.walletType}
          ariaLabel='Wallet type'
          onSelect={(key) => setActiveWallet(key as WalletType)}
        />
      ) : null}
      <WalletTab key={active.walletType} walletType={active.walletType} creditConfig={active.creditConfig} />
    </div>
  )
}

export default WalletSection
